const request = require('request');
const config = require('./config');

const get = (token) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: config.URL_BACKEND+'/pessoa',
        method: 'GET'
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve({err: err, res: res, body:body});
      })
  })
}

const getFornecedoresF = (token,filters) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/fornecedores',
      method: 'GET',
      qs: filters
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body:body});
    });
  });
};

const getFornecedores = (token) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/fornecedores',
      method: 'GET'
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body:body});
    });
  });
};

const getFornecedoresByIdF = (token,id,filters) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/fornecedores/'+id,
      method: 'GET',
      qs: filters
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

const getFornecedoresById = (token,id) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: config.URL_BACKEND+'/fornecedores/'+id,
        method: 'GET'
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve(body)
      })
  })
}

const getByToken = (token) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: config.URL_BACKEND+'/pessoa/perfil',
        method: 'GET'
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve({err: err, res: res, body:body});
      })
  })
}

const editPerfil = (body,token) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: config.URL_BACKEND+'/pessoa/'+body.codigo,
        method: 'PUT',
        body: JSON.stringify(body)
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve({err: err, res: res, body:body});
      })
  })
}

const editRenovacao = (body,token) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: config.URL_BACKEND+'/pessoa/renovacao/'+body.codigo,
        method: 'PUT',
        body: JSON.stringify(body)
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve({err: err, res: res, body:body});
      })
  })
}

const setAtivo = (token,body) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: config.URL_BACKEND+'/pessoa/setAtivo',
        method: 'PUT',
        body: JSON.stringify(body)
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve({err: err, res: res, body:body});
      })
  })
}

const updatePermissao = (token,body) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: config.URL_BACKEND+'/pessoa/updatePermissao',
        method: 'PUT',
        body: JSON.stringify(body)
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve({err: err, res: res, body:body});
      })
  })
}

const updateRotacao = (token,body) => {
  return new Promise((resolve,reject) => {
    request({
        headers: {
          'Content-Type': 'application/json',
          'User-Token': token
        },
        uri: config.URL_BACKEND+'/pessoa/updateRotacao',
        method: 'PUT',
        body: JSON.stringify(body)
      }, (err, res, body) => {
        if (err) return reject(err);
        resolve(body)
      })
  })
}

module.exports = {
  get:get,
  getByToken:getByToken,
  getFornecedores:getFornecedores,
  getFornecedoresById:getFornecedoresById,
  getFornecedoresF:getFornecedoresF,
  getFornecedoresByIdF:getFornecedoresByIdF,
  editPerfil:editPerfil,
  setAtivo:setAtivo,
  editRenovacao:editRenovacao,
  updatePermissao:updatePermissao,
  updateRotacao:updateRotacao,
}